import React from 'react';
import styled from 'styled-components';
import CardBG from '../../assets/img/CardBackground.png'
import CardBGHome2 from '../../assets/img/CardBackground-Home2.png'
import CardBGHome3 from '../../assets/img/CardBackground-3.png'

interface CardPyramidProps {
  children?: React.ReactNode;
}

interface StyledCardProps {
  children?: React.ReactNode;
}

const StyledCard = styled.div<StyledCardProps>`
      background-color: #0b0e12;      
      color: #fff1e6 !important;
      opacity: 0.99;
      display: flex;
      flex: 1;
      border-radius: 15px;
      font-weight: bold;
      flex-direction: column;
      border: solid 2px #333438;
`;

const CardPyramid = ({ children }: CardPyramidProps) => {
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <StyledCard>
      {hasChildren ? <>{children}</> : null}
    </StyledCard>
  );
};

CardPyramid.defaultProps = {
  children: null,
};

export default CardPyramid;
